const RECIPIENT_EMAIL = 'namodigitalhub@gmail.com';
const EMAIL_SUBJECT = 'New Inquiry from Website';

function buildEmailBody(formData = {}) {
  const name = formData.name?.trim() || 'Not provided';
  const phone = formData.phone?.trim() || 'Not provided';
  const email = formData.email?.trim() || 'Not provided';
  const message = formData.message?.trim() || 'Not provided';
  const service = formData.service?.trim();

  const lines = [
    `Name: ${name}`,
    `Phone: ${phone}`,
    `Email: ${email}`,
    `Message: ${message}`,
  ];

  if (service) {
    lines.push(`Service: ${service}`);
  }

  return lines.join('\n');
}

/**
 * Open the user's default email client with prefilled inquiry details.
 *
 * @param {Object} formData
 * @param {string} [formData.name]
 * @param {string} [formData.email]
 * @param {string} [formData.phone]
 * @param {string} [formData.message]
 * @param {string} [formData.service]
 */
export const sendEmail = async (formData) => {
  try {
    const body = buildEmailBody(formData);
    const mailtoLink = `mailto:${RECIPIENT_EMAIL}?subject=${encodeURIComponent(
      EMAIL_SUBJECT
    )}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;

    return {
      success: true,
      message: 'Your email client has been opened. Please send the email.',
    };
  } catch (error) {
    return {
      success: false,
      message: 'Could not open your email client. Please try again.',
      error,
    };
  }
};
